(function () {
  'use strict';

  var ODOO_ORIGIN = 'https://vennskap.odoo.com';
  var SELECTOR = 'iframe[src*="vennskap.odoo.com"]';

  var PLACEHOLDER_H = 480;
  var MIN_H = 120;
  var LOADER_TIMEOUT = 8000;
  var HELLO_EVERY = 300;
  var HELLO_FOR = 20000;

  var frames = [];
  var scanScheduled = false;

  function setup(iframe) {
    if (iframe.dataset.odooEmbed === '1') {
      return;
    }

    iframe.dataset.odooEmbed = '1';

    var entry = {
      el: iframe,
      acked: false,
      loaderTimer: 0,
      helloTimer: 0,
      helloStop: 0
    };

    frames.push(entry);
    iframe.addEventListener('load', function () { hello(entry); });

    arm(entry);
  }

  function arm(entry) {
    disarm(entry);

    entry.acked = false;
    entry.el.classList.remove('ready');

    entry.loaderTimer = window.setTimeout(function () { 
      giveUp(entry); 
    }, LOADER_TIMEOUT);

    entry.helloTimer = window.setInterval(function () { 
      hello(entry); 
    }, HELLO_EVERY);

    entry.helloStop = window.setTimeout(function () { 
      stopHello(entry); 
    }, HELLO_FOR);

    hello(entry);
  }

  function stopHello(entry) {
    window.clearInterval(entry.helloTimer);
    window.clearTimeout(entry.helloStop);
  }

  function disarm(entry) {
    stopHello(entry);
    window.clearTimeout(entry.loaderTimer);
  }

  function hello(entry) {
    if (
      entry.acked ||
      !entry.el.contentWindow
    ) {
      return;
    }

    entry.el.contentWindow.postMessage(
      { type: 'odoo:hello', origin: window.location.origin },
      ODOO_ORIGIN
    );
  }

  function giveUp(entry) {
    if (entry.acked) {
      return;
    }

    if (!entry.el.style.height) {
      entry.el.style.height = PLACEHOLDER_H + 'px';
    }

    entry.el.classList.add('ready');
  }

  function apply(entry, height, source) {
    entry.acked = true;
    disarm(entry);

    entry.el.style.height = Math.max(height, MIN_H) + 'px';
    entry.el.classList.add('ready');

    if (source) {
      source.postMessage({ type: 'odoo:applied' }, ODOO_ORIGIN);
    }
  }

  function find(source) {
    var found = null;

    frames = frames.filter(function (entry) {
      if (!entry.el.isConnected) {
        disarm(entry);
        return false;
      }

      if (entry.el.contentWindow === source) {
        found = entry;
      }

      return true;
    });

    return found;
  }

  window.addEventListener('message', function (event) {
    if (event.origin !== ODOO_ORIGIN) {
      return;
    }

    var data = event.data;

    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {
        return;
      }
    }

    if (!data) {
      return;
    }

    var entry = find(event.source);

    if (!entry) {
      return;
    }

    if (data.type === 'odoo:unloading') {
      arm(entry);
      return;
    }

    if (data.type !== 'odoo:resize') {
      return;
    }

    var height = parseInt(data.height, 10);

    if (!height) {
      return;
    }

    apply(entry, height, event.source);
  });

  function scan(root) {
    var nodes = (root || document).querySelectorAll(SELECTOR);

    for (var i = 0; i < nodes.length; i++) {
      setup(nodes[i]);
    }
  }

  function scheduleScan() {
    if (scanScheduled) {
      return;
    }

    scanScheduled = true;
    requestAnimationFrame(function () {
      scanScheduled = false;
      scan();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        scheduleScan();
        return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();